<template>
  <main class="main profile-page page-inside">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="content">
            <div class="content__head">
              <div class="head__title title">My profile</div>
              <div
                v-if="status !== 'approved'"
                id="sumsub-websdk-container"
              ></div>
              <div class="head__refresh"></div>
            </div>

            <div class="content__container">
              <div class="top">
                <div class="checkout-step-list">
                  <div class="checkout-step-list__item">
                    <div class="checkout-step__title title">
                      Personal information
                    </div>

                    <form @submit.prevent="updateProfileData" class="form">
                      <div class="row">
                        <label>
                          <input
                            required
                            type="text"
                            placeholder="Name"
                            v-model="name"
                          />
                        </label>
                      </div>

                      <div class="row">
                        <label>
                          <input
                            required
                            type="text"
                            placeholder="Surname"
                            v-model="surname"
                          />
                        </label>
                      </div>

                      <div class="row">
                        <label>
                          <input
                            required
                            type="email"
                            placeholder="email"
                            v-model="email"
                          />
                        </label>
                      </div>

                      <div class="row">
                        <button
                          :disabled="!name || !surname || !email"
                          type="submit"
                          :class="[
                            'button',
                            { disabled: !name || !surname || !email },
                          ]"
                        >
                          Update
                        </button>
                      </div>
                    </form>
                  </div>
                  <div class="checkout-step-list__item">
                    <div class="checkout-step__title small title">
                      Two-factor authentication
                    </div>

                    <div class="checkout-step__desc desc">
                      Use Google Authenticator for 2-factor account security. By default, we will always send emails
                      regarding sensitive account actions.
                    </div>

                    <button 
                      class="button gray google-2fa" 
                      @click="openTwoFactorModal('enable')" 
                      v-if="!is2FAEnabled"
                    >
                      Your account is not secure
                    </button>
                    
                    <button 
                      class="button primary google-2fa" 
                      @click="openTwoFactorModal('disable')" 
                      v-else-if="is2FAEnabled && !is2FASetupRequired"
                    >
                      Your account is secure
                    </button>

                    <button 
                      class="button primary google-2fa" 
                      @click="openTwoFactorModal('setup')" 
                      v-else-if="is2FAEnabled && is2FASetupRequired"
                    >
                      Complete 2FA Setup
                    </button>

                    <div class="checkout-step__desc google desc">
                      <p>Google Authenticator</p>
                      <img src="@/images/google-authenticator.svg" alt="Google Authenticator" />
                      <p @click="openTwoFactorModal(is2FAEnabled ? 'disable' : 'enable')" class="enable-2fa" :class="is2FAEnabled ? 'disable' : ''">
                        {{ is2FAEnabled ? 'Disable 2FA' : 'Enable 2FA' }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="middle">
                <div class="info-left">
                  <div class="checkout-step-list">
                    <div class="checkout-step-list column">
                      <div class="checkout-step-list__item">
                        <div class="checkout-step__title title">
                          Change Password
                        </div>
                        <form @submit.prevent="updatePassword" class="form">
                          <div class="row">
                            <label>
                              <input required type="text" placeholder="Enter current password" v-model="curPass" />
                            </label>
                          </div>
                          <div class="row">
                            <label>
                              <input required type="text" placeholder="New Password" v-model="newPass" />
                            </label>
                          </div>
                          <div class="row">
                            <label>
                              <input required type="text" placeholder="Re-type New Password" v-model="repeatPass" />
                            </label>
                          </div>
                          <div class="row">
                            <button :disabled="!curPass ||
                              !newPass ||
                              !repeatPass ||
                              newPass !== repeatPass
                              " type="submit" :class="[
                                'button',
                                {
                                  disabled:
                                    !curPass ||
                                    !newPass ||
                                    !repeatPass ||
                                    newPass !== repeatPass,
                                },
                              ]">
                              Update
                            </button>
                          </div>
                        </form>
                      </div>
                      <div class="checkout-step-list__item">
                        <div class="checkout-step__title small title">
                          Log Out
                        </div>
                        <div class="checkout-step__desc desc">
                          You`ll need to log in again to access to your account.
                        </div>
                        <button @click="$parent.logout" class="button gray">
                          Log out
                        </button>
                      </div>
                    </div>
                    <div class="checkout-step-list__item activity">
                      <div class="checkout-step__title title">
                        Account Activity
                      </div>

                      <ActivityTable :activities="paginatedActivity" />
                      <div class="pagination" v-if="activityPageCount > 1">
                        <button @click="activityPage = Math.max(1, activityPage - 1)" :disabled="activityPage === 1">
                          <img src="@/images/arrow.svg" style="transform: rotate(180deg); width: 18px; height: 18px;" alt="Prev" />
                        </button>
                        <button @click="activityPage = Math.min(activityPageCount, activityPage + 1)" :disabled="activityPage === activityPageCount">
                          <img src="@/images/arrow.svg" style="width: 18px; height: 18px;" alt="Next" />
                        </button>
                      </div>
                    </div>


                  </div>
                </div>
                <div class="info-right">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Teleport to="body">
      <TwoFactorModal v-if="showTwoFactorModal" @close="closeTwoFactorModal" :mode="twoFactorModalMode" />
    </Teleport>
  </main>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import ActivityTable from "@/components/ActivityTable.vue";
import snsWebSdk from "@sumsub/websdk";
import TwoFactorModal from "../components/TwoFactorModal.vue";

export default {
  name: "Profile",
  props: [],
  components: { ActivityTable, TwoFactorModal },
  data: function () {
    return {
      curPass: "",
      newPass: "",
      repeatPass: "",
      email: "",
      name: "",
      surname: "",
      phone: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
      token: "",
      status: "",
      webEnrolmentUrl: null,
      sessionId: null,
      activity: [],
      showTwoFactorModal: false,
      twoFactorModalMode: 'enable',
      activityPage: 1,
      activityPerPage: 8,
    };
  },
  
  async mounted() {
    const self = this;

    window.addEventListener(
      "message",
      function enrolmentCompleted(event) {
        const data = event.data;
        if (data.hasCompleted) {
          let interval = setInterval(async () => {
            const data = await self.checkEnrollmentStatus(self.sessionId);

            if (!data) {
              clearInterval(interval);
            } else if (data.status !== "pending") {
              self.SET_PROFILE_STATUS(data.account_status);
              self.status = data.account_status;
              clearInterval(interval);
            }
          }, 1500);
        } else if (data.hasError) {
          console.log("Error handling");
          this.enrollKyc();
        }
      },
      false
    );

    this.fetchActivity();

    this.$http
      .get(process.env.VUE_APP_API + "user/profile")
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
        this.status = res.data.status;
        
        
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      });

    await this.enrollKyc();
    this.$http
      .get(process.env.VUE_APP_API + "sumsub-token")
      .then((res) => {
        this.token = res.data.token;
        this.launchWebSdk(this.token, this.email, this.phone);
      })
      .catch(() => { });
  },
  methods: {
    launchWebSdk(accessToken, applicantEmail, applicantPhone) {
      let snsWebSdkInstance = snsWebSdk
        .init(
          accessToken,
          () => this.getNewAccessToken()
        )
        .withConf({
          levelName: "Without KYC",
          lang: "en", 
          email: applicantEmail,
          phone: applicantPhone,
          i18n: {
            document: {
              subTitles: {
                IDENTITY: "Upload a document that proves your identity",
              },
            },
          },
          uiConf: {
            customCssStr:
              ":root {\n  --black: #000000;\n   --grey: #F5F5F5;\n  --grey-darker: #B2B2B2;\n  --border-color: #DBDBDB;\n}\n\np {\n  color: var(--black);\n  font-size: 16px;\n  line-height: 24px;\n}\n\nsection {\n  margin: 40px auto;\n}\n\ninput {\n  color: var(--black);\n  font-weight: 600;\n  outline: none;\n}\n\nsection.content {\n  background-color: var(--grey);\n  color: var(--black);\n  padding: 40px 40px 16px;\n  box-shadow: none;\n  border-radius: 6px;\n}\n\nbutton.submit,\nbutton.back {\n  text-transform: capitalize;\n  border-radius: 6px;\n  height: 48px;\n  padding: 0 30px;\n  font-size: 16px;\n  background-image: none !important;\n  transform: none !important;\n  box-shadow: none !important;\n  transition: all 0.2s linear;\n}\n\nbutton.submit {\n  min-width: 132px;\n  background: none;\n  background-color: var(--black);\n}\n\n.round-icon {\n  background-color: var(--black) !important;\n  background-image: none !important;\n}",
          },
        })
        .withOptions({ addViewportTag: false, adaptIframeHeight: true })
        .on("idCheck.stepCompleted", (payload) => {
          console.log("stepCompleted", payload);
        })
        .on("idCheck.onError", (error) => {
          console.log("onError", error);
        })
        .build();

      snsWebSdkInstance.launch("#sumsub-websdk-container");
    },
    async enrollKyc() {
      const { enrolment_url, session_id } = await this.initializeEnrollment();

      if (enrolment_url && session_id) {
        this.webEnrolmentUrl = enrolment_url;
        this.sessionId = session_id;
      }
    },
    getNewAccessToken() {
      return Promise.resolve(this.token); 
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        surname: this.surname,
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.$toast("Personal information successfully updated.", {
              type: "success",
            });
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    updatePassword() {
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };

      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.curPass = "";
            this.newPass = "";
            this.repeatPass = "";

            this.$toast("Password successfully updated.", {
              type: "success",
            });
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    ...mapActions("user", ["checkEnrollmentStatus", "initializeEnrollment"]),
    ...mapMutations("user", ["SET_PROFILE_STATUS"]),
    async fetchActivity() {
      try {
        const {
          data: { payload },
        } = await this.$http.get(
          process.env.VUE_APP_API + "user/account-activity"
        );

        this.activity = payload;
      } catch (e) {
        console.error(e);
      }
    },
    openTwoFactorModal(mode) {
      this.twoFactorModalMode = mode;
      if (mode === 'disable') {
        this.$store.commit('twoFactor/SET_SETUP_MODE', true);
        this.$store.commit('twoFactor/SET_SETUP_STEP', 'verify');
        this.showTwoFactorModal = true;
      } else if (mode === 'enable' || mode === 'setup') {
        this.$store.dispatch('twoFactor/setup2FA').then(result => {
          if (result.success) {
            this.showTwoFactorModal = true;
          } else {
            this.$toast("Failed to generate QR code. Please try again.", {
              type: "error",
            });
          }
        }).catch(error => {
          console.error("Error setting up 2FA:", error);
          this.$toast("An error occurred while setting up 2FA.", {
            type: "error",
          });
        });
      }
    },

    closeTwoFactorModal() {
      this.showTwoFactorModal = false;
    },
  },
  computed: {
    statusTitle() {
      if (this.status === "approved") {
        return "Verified";
      } else if (this.status === "denied") {
        return "Not Verified";
      } else if (this.status === "new") {
        return "Not Verified";
      }

      return "";
    },
    paginatedActivity() {
      const start = (this.activityPage - 1) * this.activityPerPage;
      const end = start + this.activityPerPage;
      return this.activity.slice(start, end);
    },
    activityPageCount() {
      return Math.ceil(this.activity.length / this.activityPerPage) || 1;
    },
    ...mapGetters('user', ['is2FAEnabled', 'is2FASetupRequired']),
  },
};
</script>
<style scoped>

.checkout-step-list.column {
  flex-direction: column;
}
.profile-page .wrapper .content__container .top .checkout-step-list__item .checkout-step__title {
  margin-bottom: 32px;
}

.checkout-step-list__item.activity {
  flex: 1;
  max-width: unset;
  overflow-x: auto;

}
.checkout-step-list__item.activity .checkout-step__title {
  font-size: 24px;
  line-height: 34px;
  margin-bottom: 32px;
}

.checkout-step__desc.desc {
  display: flex;
  margin-bottom: 32px;
  gap: 6px;
}

.checkout-step__desc.desc.google {
  font-size: 12px;
}

.button.google-2fa {
  margin-bottom: 28px;
  padding: 14px 34px 14px;
  max-width: fit-content;
}

.enable-2fa {
  text-decoration: underline;
  cursor: pointer;
}

.enable-2fa.disable {
  color: #ff4766;
}
</style>